// https://caniuse.com/#feat=classlist

let support = false;
if (document.documentElement.classList) {
  support = {};
  let el = document.createElement('div');

  el.classList.add('a', 'b');
  support.multipleArguments = (el.className === 'a b');

  el.classList.add('c');
  support.toggleForceArgument = (el.classList.toggle('c', true) && el.classList.contains('c'));
}

const proto = DOMTokenList.prototype;

if (!support.multipleArguments) {
  const previousAdd = proto.add;
  const previousRemove = proto.remove;

  proto.add = function () {
    [...arguments].forEach(c => previousAdd.call(this, c));
  };
  proto.remove = function () {
    [...arguments].forEach(c => previousRemove.call(this, c));
  };
}

// https://developer.mozilla.org/docs/Web/API/DOMTokenList/toggle
if (!support.toggleForceArgument) {
  const previousToggle = proto.toggle;
  proto.toggle = function (value, force) {
    if (force === true) {
      this.add(value);
    } else if (force === false) {
      this.remove(value);
    } else {
      return previousToggle.call(this, value);
    }
    return this.contains(value);
  };
}
